import React, { Component } from 'react'

import QRCode from 'react-qr-code'
import 'react-confirm-alert/src/react-confirm-alert.css'

import './styles.css'

class PdfVoucher extends Component {

    state = {
        qrCode: {
            chaveVoucher: this.props.voucher.chave,

            chaveProduto: this.props.voucher.chave_produto,

            chaveUnidade: this.props.voucher.chave_unidade,

            chave_usuario: this.props.voucher.chave_usuario,

        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.voucher.chave != this.props.voucher.chave) {
            this.setState({
                chaveVoucher: this.props.voucher.chave,

                chaveProduto: this.props.voucher.chave_produto,

                chaveUnidade: this.props.voucher.chave_unidade,

                chave_usuario: this.props.voucher.chave_usuario,
            })
        }
    }

    render() {
        return (
            <div className='pdf_voucher_wrapper' id='pdfDiv'>
                <h5 className='pdf_voucher_title'>
                    Unidade de consumo: {this.props.voucher.unidadeNome}
                </h5>
                <h5 className='pdf_voucher_title'>
                    Cliente: {this.props.voucher.empresaNome}
                </h5>
                <div className='pdf_voucher_cards'>
                    {[...Array(this.props.quantity)].map((e, index) => (
                        <div className='pdf_voucher_card' key={index}>
                            <span className='pdf_voucher_card_title'>
                                {this.props.voucher.tipo == "USUARIO" ? `Uso exclusivo de ${this.props.voucher.pessoaNome}` : ""}
                            </span>
                            <div className='pdf_voucher_qrcode_wrapper'>
                                <QRCode
                                    className='pdf_voucher_qrcode'
                                    value={JSON.stringify({
                                        chaveVoucher: this.props.voucher.chave,
                                        chaveProduto: this.props.voucher.chave_produto,
                                        chaveUnidade: this.props.voucher.chave_unidade,
                                        chave_usuario: this.props.voucher.chave_usuario,
                                    })}
                                    fgColor='#000000'
                                    bgColor='#FFFFFF'
                                />
                            </div>
                            <span className='pdf_voucher_footer'>
                                {this.props.voucher.produtoNome}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default PdfVoucher;